import { render, staticRenderFns } from "./look_subordinates_box.vue?vue&type=template&id=7f6a5556&scoped=true"
import script from "./look_subordinates_box.vue?vue&type=script&lang=js"
export * from "./look_subordinates_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a5556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6a5556')) {
      api.createRecord('7f6a5556', component.options)
    } else {
      api.reload('7f6a5556', component.options)
    }
    module.hot.accept("./look_subordinates_box.vue?vue&type=template&id=7f6a5556&scoped=true", function () {
      api.rerender('7f6a5556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/position_information/associated/look_subordinates/look_subordinates_box.vue"
export default component.exports